/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  widgetLabel: {
    id: "b2b.zadosti-odbaveni-widget.label",
    defaultMessage: "Request processing"
  },
  messageEmpty: {
    id: "b2b.zadosti-odbaveni-widget.message-empty",
    defaultMessage: "No requests to process."
  }
});

export default () => useMessages(MESSAGES);
